// src/pages/account/NotificationsPage.jsx
import NotificationsPanel from "./NotificationsPanel";
export default function NotificationsPage() {
  return <NotificationsPanel />;
}